import '../scss/index.scss';

import Accordion from './accordion';

var accordionToggles = document.getElementsByClassName('accordion-toggle');
Array.from(accordionToggles).forEach((toggle) => {
    var id = toggle.getAttribute('data-accordion');
    var accordion = document.getElementById(id);
    var a = new Accordion(accordion, toggle);
});


if (module.hot) {
    module.hot.accept();
}